import { render, staticRenderFns } from "./SectionPreviewGallery.vue?vue&type=template&id=01bb66cc&"
import script from "./SectionPreviewGallery.vue?vue&type=script&lang=ts&"
export * from "./SectionPreviewGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports